<section id="landing_aceptacion-aliado" class="landing-aliado">
  <app-header-public
    variant="v2"
    [showAuthButtons]="true"
    [showRegisterButton]="false"
    [loginRouterLink]="'/intermediario/login'"
  ></app-header-public>

  <div class="landing-aliado__vigilado" aria-hidden="true">
    <img
      class="landing-aliado__vigilado-img"
      src="assets/img/Home/hero/Ico_super.svg"
      alt=""
    />
  </div>

  <main class="landing-aliado__main">
    <div class="landing-aliado__hero">
      <div class="landing-aliado__bg" aria-hidden="true"></div>

      <div class="landing-aliado__visual-mobile" aria-hidden="true">
        <span class="landing-aliado__bubble landing-aliado__bubble--tl-lg"></span>
        <span class="landing-aliado__bubble landing-aliado__bubble--tl-sm"></span>
        <img
          class="landing-aliado__visual-mobile-img"
          src="assets/img/login/login-if-mobile.png"
          alt=""
        />
      </div>

      <h1 class="landing-aliado__hero-title">Inicio de sesión</h1>

      <span
        class="landing-aliado__bubble landing-aliado__bubble--br-lg landing-aliado__bubble--desktop"
        aria-hidden="true"
      ></span>
      <span
        class="landing-aliado__bubble landing-aliado__bubble--br-sm landing-aliado__bubble--desktop"
        aria-hidden="true"
      ></span>

      <div class="landing-aliado__panel">
        <span
          class="landing-aliado__bubble landing-aliado__bubble--tl-lg landing-aliado__bubble--desktop"
          aria-hidden="true"
        ></span>
        <span
          class="landing-aliado__bubble landing-aliado__bubble--tl-sm landing-aliado__bubble--desktop"
          aria-hidden="true"
        ></span>

        <p class="landing-aliado__eyebrow">Has terminado el registro exitosamente</p>

        <p class="landing-aliado__welcome">Te damos la bienvenida a</p>

        <img
          class="landing-aliado__brand"
          src="assets/img/Home/svg/logo-neocredito-header.svg"
          alt="neocrédito"
          width="220"
          height="36"
        />

        <button
          type="button"
          class="landing-aliado__btn"
          id="btn-landing-aliado-inicia-sesion"
          (click)="goToLogin()"
        >
          Inicia sesión
        </button>
      </div>
    </div>
  </main>

  <app-home-site-footer></app-home-site-footer>
</section>
